import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import MaskedInput from "react-text-mask";
import "./styles.scss";

import { ptBR } from "date-fns/locale/pt-BR";

registerLocale("pt-BR", ptBR);
setDefaultLocale("pt-BR");

type DatepickerProps = {
	label: string;
	selectedDate: Date | null | undefined;
	onChange: (date: any) => void;
	showYearPicker?: boolean;
	maxDate?: Date;
	minDate?: Date;
	onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
	error?: string | Array<string>;
	touched?: boolean;
	disabled?: boolean;
	isRequired?: boolean;
};

export default function Datepicker({
	label,
	selectedDate,
	onChange,
	showYearPicker,
	maxDate,
	minDate,
	onBlur,
	error,
	touched,
	disabled = false,
	isRequired = true
}: DatepickerProps) {
	const handleChange = (date: Date | null) => {
		if (!date) return;

		if (showYearPicker) {
			onChange(date.getFullYear());
			return;
		}
		onChange(date);
	};

	return (
		<div className="datepicker">
			<label htmlFor="date">{label}</label>
			{isRequired && <span className="text-feedback-negative-pure-500"> *</span>}

			<DatePicker
				selected={selectedDate}
				onChange={handleChange}
				dateFormat={showYearPicker ? "yyyy" : "dd/MM/yyyy"}
				dateFormatCalendar={showYearPicker ? "yyyy" : undefined}
				placeholderText="Digite"
				showYearPicker={showYearPicker}
				yearItemNumber={12}
				maxDate={maxDate}
				minDate={minDate}
				onBlur={onBlur}
				className={
					error && touched
						? "bg-feedback-negative-high-50 border-feedback-negative-pure-500 focus-visible:outline-feedback-negative-pure-500"
						: ""
				}
				customInput={!showYearPicker ? <MaskedInput mask={[/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/]} /> : undefined}
				disabled={disabled}
			/>
			{error && touched && <div className="white-space--pre-line mt-1 text-xs">{Array.isArray(error) ? error.join("\n") : error}</div>}
		</div>
	);
}
